export function normalizeTopMessages(topMessages) {
	if (!Array.isArray(topMessages)) {
		return [];
	}
	const seen = new Set();
	return topMessages.filter((item) => {
		if (!item || item.id === undefined || item.id === null) {
			return false;
		}
		const key = String(item.id);
		if (seen.has(key)) {
			return false;
		}
		seen.add(key);
		return true;
	});
}

export function removeTopMessages(topMessages, removedIds = []) {
	const normalizedTopMessages = normalizeTopMessages(topMessages);
	if (!Array.isArray(removedIds) || removedIds.length === 0) {
		return normalizedTopMessages;
	}
	const removedIdSet = new Set(
		removedIds
			.filter((id) => id !== undefined && id !== null && id !== '')
			.map((id) => String(id))
	);
	if (removedIdSet.size === 0) {
		return normalizedTopMessages;
	}
	return normalizedTopMessages.filter((item) => !removedIdSet.has(String(item.id)));
}

export function getTopMessageExpectation(topMessages) {
	const normalizedTopMessages = normalizeTopMessages(topMessages);
	const latestTopMessage = normalizedTopMessages.length
		? normalizedTopMessages[normalizedTopMessages.length - 1]
		: null;
	return {
		expectedTopCount: normalizedTopMessages.length,
		expectedLatestId: latestTopMessage && latestTopMessage.id !== undefined && latestTopMessage.id !== null
			? String(latestTopMessage.id)
			: ''
	};
}

export function resolveTopMessageSyncState({
	localTopMessages,
	incomingTopMessages,
	expectedTopCount,
	expectedLatestId,
	preserveOnMismatch = false
}) {
	const fallbackTopMessages = normalizeTopMessages(localTopMessages);
	if (!Array.isArray(incomingTopMessages)) {
		const matched = typeof expectedTopCount !== 'number' && expectedLatestId === undefined;
		return {
			matched,
			topMessages: fallbackTopMessages,
			actualTopCount: fallbackTopMessages.length,
			actualLatestId: getTopMessageExpectation(fallbackTopMessages).expectedLatestId
		};
	}
	const normalizedIncomingTopMessages = normalizeTopMessages(incomingTopMessages);
	const actualTopCount = normalizedIncomingTopMessages.length;
	const actualLatestId = getTopMessageExpectation(normalizedIncomingTopMessages).expectedLatestId;
	const countMatched = typeof expectedTopCount !== 'number' || actualTopCount === expectedTopCount;
	const latestMatched = expectedLatestId === undefined || actualLatestId === String(expectedLatestId ?? '');
	const matched = countMatched && latestMatched;
	return {
		matched,
		topMessages: preserveOnMismatch && !matched
			? fallbackTopMessages
			: normalizedIncomingTopMessages,
		actualTopCount,
		actualLatestId
	};
}
